export const LabelMap = (key, value) => {
    value = (value) ? value : '';
    switch(key) {
        case 'blocked':
            return 'S-Blocked'
        case 'severity':
            return 'SEV' + value
        case 'release':
            return 'release_' + value
        default:
    }
}


// WEBPACK FOOTER //
// ./src/js/others/LabelMap.js